import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogUploader from "@/shared/ui/SogUploader.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import {ref, watch} from "vue";
import {TempFileInfo} from "@/shared/model/TempFileInfo";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {UploaderComponent} from "@syncfusion/ej2-vue-inputs";
import apiTest from "@/modules/Test/api";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";

interface Props {
  modelValue?:{id?:string,fileName?:string,name?:string}
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'TempFileFormComponent',
  props: {
    modelValue: { default: undefined }
  },
  emits: ["change", "update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {


const props = __props

const _emit = __emit;

const _fileName = ref<{id:string,fileName:string}>({id:"",fileName:""})
const _camera = ref(false)


const _array = ref<TempFileInfo[]>([])
const _name = ref("")
const _uploader = ref<InstanceType<typeof UploaderComponent>  | null>(null)


watch(([_array,_name,_fileName]),()=>{
  let value = undefined;
  if(_camera.value&&_fileName.value){
    value = {id:_fileName.value.id,fileName:_fileName.value.fileName,name:_name.value}
  }
  if(_array.value.length>0) {
    value = {id: _array.value[0].id, fileName: _array.value[0].fileName, name: _name.value}
  }
  _emit("update:modelValue",value)
  _emit("change")
})


async function onCameraChange() {
  console.log("§§§")

  const input = document.getElementById('myFileInput') as HTMLInputElement; // HTML-Element für die Anzeige des Kamerabildes
  if (!input.files)
    return

  if (input.files.length > 0) {
    const file = input.files[0];

    console.log(file.name)

    const id = await apiTest.uploadTempFile(file.name, file)
    if(!id)
      return
    _fileName.value = {id:id,fileName:file.name}
    console.log(_fileName.value)
  }

}

function clear () {
  _uploader.value?.clear()
  _camera.value = false;
}

function takePhoto() {
  console.log("take")
  _camera.value = true
  const input = document.getElementById('myFileInput') as HTMLInputElement; // HTML-Element für die Anzeige des Kamerabildes

  if(input)
    input.click()
}

__expose({
  clear,takePhoto
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Wählen Sie ein Datei aus", -1)
        ]))]),
        _: 1
      }),
      _withDirectives(_createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogUploader, {
            ref_key: "_uploader",
            ref: _uploader,
            modelValue: _array.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_array).value = $event)),
            multiple: false
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 512), [
        [_vShow, !_camera.value]
      ]),
      _withDirectives(_createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogFormField, null, {
            default: _withCtx(() => [
              _createVNode(SogTextBox, {
                modelValue: _name.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_name).value = $event)),
                placeholder: "Name"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(SogFormField, null, {
            default: _withCtx(() => [
              _createVNode(SogDataLabel, {
                value: _fileName.value.fileName
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _fileName.value]
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, _array.value.length>0||_fileName.value]
      ]),
      _createVNode(SogCardContent, { hidden: "hidden" }, {
        default: _withCtx(() => [
          _createElementVNode("input", {
            id: "myFileInput",
            type: "file",
            accept: "image/*",
            capture: "camera",
            onChange: onCameraChange
          }, null, 32)
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})